// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IAfNl","tabsBox":"styles_tabsBox__2Tc7N","createButton":"styles_createButton__1puy_"};